import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress, InputLabel, MenuItem, Select } from "@mui/material";
import ErrorMessageComponent from "./ErrorMessageComponent";
import { setDevice } from "../redux/slices/deviceSlice";

import FormControl from "@material-ui/core/FormControl";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  paddingTop: 1,
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 300,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldContainer: {
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
  },
   submitButton: {
    textTransform: "none",
    marginLeft: "70%",
  },
  label: {
    fontWeight: "bold",
  },
}));

export default function MyDeviceForm() {
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const dispatch = useDispatch();
  const oldDeviceData = useSelector((state) => state.device);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccessMessage] = useState();
  const [formData, setFormData] = useState({
    name: "",
    serial: "",
    ipAddress: "",
    portNumber: "",
    model: "",
    type: "",
  });
  const api = localStorage.getItem("api");
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const requestBody = { ...formData };
    if (requestBody?.type?.length == 0) {
      requestBody.type = null;
    }
    
    axios
      .post(api + `/device`, { ...requestBody }, { headers: headers.headers })
      .then((response) => {
        setIsSubmitting(false);
        if (response.status === 200) {
          const combinedData = [...oldDeviceData.device, response.data[0]];

          setErrorModalOpen(true);
          setErrorMessage(`Device added successfully`);
          setSuccessMessage(true);
          setFormData({
            name: "",
            serial: "",
            ipAddress: "",
            portNumber: "",
            model: "",
            type: "",
          });

          try {
            dispatch(setDevice(combinedData));
          } catch (e) {
            console.log(e);
          }
        }
      })
      .catch((error) => {
        setErrorModalOpen(true);
        let errorMessage;

        errorMessage = `Error creating service: <b>${error.response.data}</b><br/>`;

        setErrorMessage(errorMessage);

        setSuccessMessage(false);
        setFormData({
          name: "",
          serial: "",
          ipAddress: "",
          portNumber: "",
          model: "",
          type: "",
        });
      });

    fetchData();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  function fetchData() {
    axios
      .get(api + `/list/device`, headers)
      .then((response) => {
        dispatch(setDevice(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Device
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <h2>Elhi Devices </h2>
            <h4 style={{ fontWeight: "100" }}>
              Add new Elhi device to the Landscape Manager{" "}
            </h4>
          </div>
          <br />
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Name:", true)}
                  <TextField
                    required
                    id="name"
                    label="Alias for the Device"
                    name="name"
                    size="small"
                    variant="outlined"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Serial:", true)}
                  <TextField
                  required
                    id="serial"
                    label="Serial"
                    name="serial"
                    variant="outlined"
                    size="small"
                    value={formData.serial}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("IP Address:", true)}
                  <TextField
                    required
                    id="ipAddress"
                    label="http://X.X.X.X or https://X.X.X.X"
                    name="ipAddress"
                    variant="outlined"
                    value={formData.ipAddress}
                    onChange={handleChange}
                    size="small"
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Port Number:", true)}
                  <TextField
                    required
                    id="portNumber"
                    label="Generally it is 8081"
                    name="portNumber"
                    variant="outlined"
                    value={formData.portNumber}
                    onChange={handleChange}
                    size="small"
                  />
                </div>
              </div>

              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Model:", true)}
                <TextField
                  required
                  id="model"
                  label="Model of the device"
                  name="model"
                  variant="outlined"
                  value={formData.model}
                  onChange={handleChange}
                  size="small"
                />
              </div>

              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Type:", true)}
                <FormControl variant="outlined" size="small">
                  <InputLabel required>Type of the device</InputLabel>
                  <Select
                    id="type"
                    required
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    label="Type of the device"
                  >
                    <MenuItem value="sPresence">sPresence</MenuItem>
                    <MenuItem value="truOccupancy">truOccupancy</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <Button
              style={{ textTransform: "none", marginLeft: "80%" }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
            </Button>

            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                {success ? <h2>Congratulations!</h2> : <h2>Error: </h2>}
                <ErrorMessageComponent errorMessage={errorMessage} />
                <Button
                  style={{
                    textTransform: "none",
                    marginTop: "2%",
                    marginLeft: "75%",
                  }}
                  onClick={handleModalClose}
                  variant="outlined"
                  color="error"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
